var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplymainjsmobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 148,
    viewBox: "0 0 152 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.625 35.044 30.542 15.531l-.172 17.866 37.1 19.514.155-17.867z",
    fill: "url(#gojy0udqja)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m39.992 24.84 11.156 5.87-.017 2.143-11.156-5.87.017-2.143zM39.957 29.143l23.758 12.492-.017 2.175L39.94 31.318l.017-2.175z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.011 25.48c-.017 1.471-.964 2.175-2.134 1.551-1.171-.608-2.1-2.303-2.083-3.775.017-1.471.964-2.175 2.134-1.551 1.171.623 2.1 2.303 2.084 3.775z",
    fill: "#F2C94C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m152 115.083-37.1-19.498-.173 17.866 37.118 19.498.155-17.866z",
    fill: "url(#pxlwigacjb)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m124.352 104.878 11.156 5.87-.017 2.143-11.156-5.87.017-2.143zM124.336 109.181l23.758 12.492-.017 2.175-23.759-12.492.018-2.175z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.39 105.534c-.017 1.471-.964 2.175-2.134 1.551-1.171-.608-2.101-2.303-2.084-3.775.018-1.471.965-2.175 2.135-1.551 1.171.608 2.101 2.287 2.083 3.775z",
    fill: "#F2C94C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M108.735.704c-6.99 1.263-22.708 2.895-29.56-.704.052 25.464 6.766 61.596 28.717 91.394 22.294-6.541 29.611-35.3 30.128-60.444-6.852-3.615-22.381-21.673-29.285-30.246z",
    fill: "url(#iv792c7h3c)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M100.196 5.982c-6.99 1.264-22.708 2.895-29.56-.704.052 25.448 6.766 61.58 28.717 91.379 22.294-6.542 29.611-35.285 30.127-60.445-6.852-3.615-22.38-21.657-29.284-30.23z",
    fill: "url(#06p48meswd)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M129.48 36.212c-6.869-3.615-22.38-21.657-29.284-30.23l-.843 90.675c22.294-6.542 29.611-35.285 30.127-60.445z",
    fill: "url(#kvyhrvc6ge)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m63.389 53.855 34.345 18.058L97.028 148 62.7 129.942l.688-76.088z",
    fill: "url(#ns969chgdf)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.45 88.387 93.345 102l-.19 21.145-25.91-13.612.207-21.145z",
    fill: "url(#oxm2djtj8g)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m68.09 74.312 11.965 6.286-.018 2.175-11.965-6.286.018-2.175zM68.09 78.63l11.965 6.286-.018 2.176-11.965-6.286.018-2.176zM68.001 82.79l22.726 11.947-.018 2.175-22.725-11.948.017-2.175z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m63.388 53.855 34.346 18.058-.103 10.188-34.329-18.058.086-10.189z",
    fill: "url(#5jdoadu8rh)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.93 63.531c-.018 1.536-1 2.271-2.204 1.648-1.205-.64-2.17-2.4-2.152-3.935.017-1.536.998-2.271 2.204-1.648 1.205.64 2.169 2.4 2.151 3.935z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m83.482 88.356.086-8.766 23.276 12.236-.086 8.766-23.276-12.236z",
    fill: "#F2C94C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M56.676 51.36 5.442 23.88l.017 24.808 46.724 25.048 4.528 6.222-.035-28.599z",
    fill: "url(#g8p1n8jtli)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-.002 33.557v-6.734l19.334 10.365v6.734L-.002 33.557z",
    fill: "#F2C94C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M43.523 50.336 32.3 44.322v2.175l11.224 6.014v-2.175zM43.523 54.686 21.883 43.09v2.175l21.64 11.596v-2.175zM43.523 59.053l-26.22-14.06v2.175l26.22 14.06v-2.175z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.275 54.094c0 2.048 1.308 4.4 2.91 5.263 1.6.864 2.909-.096 2.909-2.143 0-2.048-1.309-4.4-2.91-5.263-1.6-.864-2.91.096-2.91 2.143z",
    fill: "#F2C94C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.198 76.92c1.033.543 1.86 1.887 1.86 2.99v4.879l3.477 1.871c1.033.544 1.86 1.887 1.86 2.991s-.827 1.552-1.86 1.008l-3.477-1.856v4.879c0 1.103-.827 1.551-1.86 1.007-1.033-.543-1.86-1.887-1.86-2.99V86.82l-3.477-1.855c-1.033-.544-1.86-1.888-1.86-2.991 0-1.104.827-1.552 1.86-1.008l3.478 1.855v-4.878c0-1.12.826-1.568 1.86-1.024z",
    fill: "url(#925irhmqyj)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gojy0udqja",
    x1: 53.143,
    y1: 27.422,
    x2: 45.749,
    y2: 41.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pxlwigacjb",
    x1: 137.515,
    y1: 107.462,
    x2: 130.12,
    y2: 121.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iv792c7h3c",
    x1: 63.671,
    y1: 8.925,
    x2: 108.47,
    y2: 52.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "06p48meswd",
    x1: 55.134,
    y1: 14.199,
    x2: 99.932,
    y2: 57.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kvyhrvc6ge",
    x1: 131.983,
    y1: 45.591,
    x2: 93.726,
    y2: 53.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ns969chgdf",
    x1: 58.714,
    y1: 81.103,
    x2: 91.926,
    y2: 116.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oxm2djtj8g",
    x1: 72.033,
    y1: 88.889,
    x2: 85.413,
    y2: 120.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5jdoadu8rh",
    x1: 75.118,
    y1: 53.956,
    x2: 84.301,
    y2: 81.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8p1n8jtli",
    x1: 45.513,
    y1: 41.423,
    x2: 20.563,
    y2: 62.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "925irhmqyj",
    x1: 43.793,
    y1: 83.158,
    x2: 35.296,
    y2: 90.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplymainjsmobile);
export default __webpack_public_path__ + "static/media/Apply main js mobile.2579cc73d6b942181297730da1bf0055.svg";
export { ForwardRef as ReactComponent };